// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__36Ass","approved":"Status_approved__1OI6F","rejected":"Status_rejected__2md5d","expired":"Status_expired__112BA","label":"Status_label__3V-0M"};